import { trans } from "@/service/i18n/i18n";
import { createPath } from "@/service/routing/routing";
import { Button } from "@/components/ui/button";

export const RestrictedIcd10Resource = ({
  type = null,
}: {
  type?: "meds" | null;
}) => {
  return (
    <div className={"bg-secondary mt-4 w-[328px] rounded-lg p-4"}>
      <p
        dangerouslySetInnerHTML={{
          __html: `${trans(
            type === "meds"
              ? "icd10.restriction.meds.not_logged_in"
              : "icd10.restriction.not_logged_in",
          )}`,
        }}
        className={"mb-4"}
      />
      <Button variant={"blue"} asChild={true}>
        <a href={createPath("security.login")}>
          {trans("icd10.restriction.log_in")}
        </a>
      </Button>
    </div>
  );
};
